import { useFindOneContactSentiment } from 'hooks/contact-sentiments';
import { useGetContactDetailByPhoneNumberQuery } from 'services';
import { ContactDto } from 'types';

export function useContactDetailByPhone(phoneNumber: string) {
  const { data: contactRes, isLoading } = useGetContactDetailByPhoneNumberQuery(phoneNumber!, {
    skip: !phoneNumber,
    refetchOnMountOrArgChange: true
  });

  const { contactSentiment, isLoadingContactSentiment } = useFindOneContactSentiment(
    {
      phoneNumber: phoneNumber
    },
    {
      skip: !phoneNumber
    }
  );

  return {
    contact: contactRes?.data
      ? ({
          ...contactRes.data,
          contactSentiment: contactSentiment || undefined
        } as ContactDto)
      : undefined,
    isLoading,
    isLoadingContactSentiment
  };
}
